import { TRIGGER_FETCH_KYC_STATUS_API, TRIGGER_FETCH_KYC_STATUS_API_SUCCESS } from 'redux/actionTypes';

export function triggerFetchKycStatusApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_FETCH_KYC_STATUS_API,
		data,
		stopLoader,
		callback,
	};
}

export function triggerFetchKycStatusApiCallSuccess(data) {
	return {
		type: TRIGGER_FETCH_KYC_STATUS_API_SUCCESS,
		data,
	};
}
